import HTTPClient from './http-client';
import moment from 'moment';

//https://api.simepar.br/alert-api/public/historicalAreaPercentageOfAlertsByCompany?companyId=1&finalDate=2023-01-04T03:00:00Z&initialDate=2023-01-03T03:00:00Z&zoneId=5
class WeatherService {
  async getHistoricalWeatherAlerts(regionalId, initialDate, finalDate) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `/public/historicalAreaPercentageOfAlertsByCompany?companyId=1&finalDate=${finalDate}&initialDate=${initialDate}&zoneId=${regionalId}`,
    );
  }

  async getAlertsActive(){
    const httpClient =  new HTTPClient()
    const api = await httpClient.configure();

    return api.get(
      `public/percentageAreaWithActiveAlertByCompany?companyId=1`
    );

  }

  async getLast24hAlerts(){
    const httpClient =  new HTTPClient()
    const api = await httpClient.configure();
    const currentDate = moment().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
    const yesterday = moment().subtract(1, 'day').format('YYYY-MM-DD[T]HH:mm:ss[Z]')
    return api.get(
      `public/historicalAreaPercentageOfAlertsByCompany?companyId=1&finalDate=${currentDate}&initialDate=${yesterday}`
    );

  }

  async getAllAlerts(finalDate, initialDate){
    const httpClient =  new HTTPClient()
    const api = await httpClient.configure();

    return api.get(
      `/public/historicalAreaPercentageOfAlertsByCompany?companyId=1&finalDate=${finalDate}&initialDate=${initialDate}`,
    );

  } 

  async getHistoricalAgenciesOnAlerts(regionalId, initialDate, finalDate) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.get(
      `/public/agenciesOnAlerts?companyId=1&finalDate=${finalDate}&initialDate=${initialDate}&zoneId=${regionalId}`,
    );
  }
}

export default new WeatherService();
